import apiClient from "../../../../../services/apiClient";


// statisticsApi.js
export const statisticsApi = {
  // Получение основной информации о посещаемости
  async getGroupAttendance(kgId, groupNumber, period, isArchive) {
    const url = `tabel_group/sum/${kgId}${isArchive ? '?isArchive=true' : ''}`;
    const data = { numberGr: groupNumber, period };
    return await apiClient.post(url, data);
  },

  // Получение временной информации о посещаемости
  async getGroupAttendanceTemp(kgId, groupNumber, period, isArchive) {
    const url = `tabel_group_temp/sum/${kgId}${isArchive ? '?isArchive=true': ''}`;
    const data = { numberGr: groupNumber, period };
    return await apiClient.post(url, data);
  },

  // Получение информации о детях группы
  async getGroupChildren(kgId, groupId, period) {
    const dateTo = new Date(period.split('.')[1], period.split('.')[0]-1, 1, 9, 0, 0).toISOString();
    const dateFrom = new Date(new Date(dateTo).getFullYear(), new Date(dateTo).getMonth() + 1, 0).toISOString();
    
    const url = `kindergartens/${kgId}/children/main_info?groups=${groupId}&date_to=${dateTo}&date_from=${dateFrom}`;
    return await apiClient.get(url);
  },

  async getKgAttendance(kgId, kgGroup, period, groups) {
    const url = `tabel_kg/sum/${kgId}`;
    const body = {"numberGr": kgGroup, "period": period};

    const transformResponse = (res, groups)=>{

      
      let resp = { 
              group:{
                  kg_id: res.data[0]._id.idKg, 
                  gr_number: res.data[0]._id.grNb,
                  month:res.data[0]._id.month
              },
              status: res.data[0]._id.status, 
              tabel:[
                  
              ] 
      }
          
      res.data.forEach((child)=>{

              let smNumb = 'недоступне';
              let bgNumber = 'недоступне';

              let arrDays = child.tabel.main.map((el,i)=>{
                  if(el === 1 || child.tabel.first[i] === 1) return 1;
                  return -1;
              });


              let gr_number = '';

              if(groups.length > 0) { 
                  
                  groups.forEach(group=> {
                      const fEl = group.children.find((el)=>el.childId === child._id.idChild); 
                      if(fEl && fEl.smallNumber) smNumb =fEl.smallNumber;
                      if(fEl) gr_number=group.number;
                  });
              };

              


              if(groups.length > 0){ 
                  
                  groups.forEach(group=> {	
                      const bNmb = group.children.find((el)=>el.childId === child._id.idChild); if(bNmb && bNmb['number']) bgNumber = bNmb.number;
                  });
              };
              

              const mr_info =  child.childInfo.mr[0] && child.childInfo.mr[0].reduce((acc, cur)=>acc || (cur && cur.statusMR && cur.statusMR.result && cur.statusMR.result == 'true'), false );


              resp.tabel.push({ 
                  child:{
                      firstName: child.childInfo.firstName[0], 
                      lastName: child.childInfo.lastName[0],
                      kyivreg: child.childInfo.kyivreg[0] && child.childInfo.kyivreg[0].result == 'true' && 'Зареєстрований' || 'Немає',
                      mrinfo: mr_info && 'Наявна' || 'Відсутня',
                      smallNumber: smNumb,
                      big_number:  bgNumber,
                      id: child._id.idChild,
                      tPl: child._id.tPl,
                      gr_number
                  }, perdays: arrDays, perdaysfirst: child.tabel.first }) 
      });

      return resp

    }

    const res = await apiClient.post(url, body);

    return res;

    //return transformResponse(res, groups);
  },

  async getKgChildren(kgId, periodStartYear, period, groups) {
    const url = `kindergartens/${kgId}/children/main_info_kg?type=only_child&period_start_year=${periodStartYear}&date_to=${new Date(period.split('.')[1], period.split('.')[0]-1,1,9,0,0).toISOString()}`;

    
    const transformResponse = (res, groups, period)=>{
      let all_groups = {children:[]};

      groups.forEach(gr=>{
          if(gr.hasOwnProperty('children')) all_groups.children =  all_groups.children.concat(gr.children);
      })
      
      let listChV = Object.assign({}, this.state.infoInvites);

      const filterData = res.data.filter(el=>el.dateFrom < new Date(period.split('.')[1], period.split('.')[0],0));
                          
      const ch_info = filterData.map( el => 
          {

              if(!el._id) return el;
              //if (!cur_group.hasOwnProperty('children')) return el;

              const infGr = all_groups.children.filter( grch => !grch.childId.localeCompare(el._id) )[0];
              //let res = Object.assign({}, el);
              if( infGr && infGr.number) el.number = infGr.number;
              if( infGr && infGr.smallNumber) el.smallNumber = infGr.smallNumber;
              return el;
          });
      
          ch_info.forEach( el =>{
              
              const mr_info = el.relationFamily && el.relationFamily.reduce((acc, cur)=>acc || (cur && cur.statusMR && cur.statusMR.result && cur.statusMR.result == 'true'), false );

              if ( el._id && !listChV.tabel.find( recCh => recCh.child.id === el._id)) listChV.tabel.push(
                  { 
                      child:{
                          firstName: el.firstName, 
                          lastName: el.lastName,
                          kyivreg: el.statusMR && el.statusMR.result && el.statusMR.result == 'true' && 'Зареєстрований' || 'Немає',
                          mrinfo: mr_info && 'Наявна' || 'Відсутня',                                        
                          smallNumber: el && el.smallNumber ? el.smallNumber:'',
                          big_number:  el.number,
                          id: el._id
                      }, perdays: [] }
              )
          });

          listChV.tabel.sort((a,b)=>{
              if(a.child.lastName > b.child.lastName) return 1;
              if(a.child.lastName < b.child.lastName) return -1;
              return 0;
          });
                       
    }
    
    const res = await apiClient.get(url);


    return res;


    //return transformResponse(res, groups, period);


  }


};